import { requestJson } from "../../service/api";

/**
 * Admin proxy: QPay POST /payment/list (read-only diagnostic). No POST retry on 502.
 * @param {Record<string, unknown>} body
 */
const qpayPaymentList = async (body) => {
  const { ok, body: resBody } = await requestJson("post", "/admin/qpay/payment/list", body);
  if (!ok) {
    return resBody || { success: false, error: { message: "Хүсэлт амжилтгүй." } };
  }
  return resBody;
};

export default qpayPaymentList;

export async function resolveQpayInvoice(invoiceId) {
  const q = encodeURIComponent(String(invoiceId));
  const { ok, body } = await requestJson("get", `/admin/qpay/resolve-invoice?invoiceId=${q}`);
  if (!ok) {
    return body || { success: false, error: { message: "QPay ID олж чадсангүй." } };
  }
  return body;
}

export async function qpayPaymentCheck(body) {
  const { ok, body: resBody } = await requestJson("post", "/admin/qpay/payment/check", body);
  if (!ok) {
    return resBody || { success: false, error: { message: "payment/check амжилтгүй." } };
  }
  return resBody;
}
